import { z } from "zod";

export const recommendMemberSchema = z.object({
	email: z.email().transform((e) => e.toLowerCase()),
});

export type RecommendMemberPayload = z.infer<typeof recommendMemberSchema>;

export const respondRecommendationSchema = z.object({
	action: z.enum(["accept", "decline"]),
});

export type RespondRecommendationPayload = z.infer<typeof respondRecommendationSchema>;

export const recommendationRequestContentSchema = z.object({
	recommendation_id: z.string(),
	group_id: z.string(),
	group_name: z.string(),
	recommender_name: z.string(),
	recommended_email: z.string(),
});

export type RecommendationRequestContent = z.infer<typeof recommendationRequestContentSchema>;

export const recommendationResponseContentSchema = z.object({
	recommendation_id: z.string(),
	group_id: z.string(),
	group_name: z.string(),
	recommended_email: z.string(),
	action: z.enum(["accepted", "declined"]),
	responded_by_name: z.string(),
});

export type RecommendationResponseContent = z.infer<typeof recommendationResponseContentSchema>;
